import { useTranslation } from "react-i18next";
import { GetRoleName, Role as UserRole } from "../models/Role";

function Role({ role }: { role: UserRole | undefined }) {
    const { t } = useTranslation();
    return <>{t(GetRoleName(role))}</>;
}

export default Role;
